import { Range } from "../geometry/Range";
import { RegExpUtility } from "../text/RegExpUtility";
import { DateHelper } from "./DateHelper";
import { DateMath } from "./DateMath";

export class DateRange
{
  start:Date;
  end:Date;

  static now()
  {
    let date = new Date();

    return DateRange.create( date );
  }

  static today()
  {
    let date = new Date();
    date.setHours( 0, 0, 0 );

    return DateRange.create( date );
  }

  static yesterday()
  {
    let date = new Date();
    date.setDate( date.getDate() - 1 );
    date.setHours( 0, 0, 0 );

    return DateRange.create( date );
  }

  static create( start:Date, end:Date = null )
  {
    let range = new DateRange();
    range.start = start;
    range.end   = end || start;
    
    return range;
  }

  static forDay( day:Date )
  {
    let start = new Date( day );
    start.setHours( 0, 0, 0 );

    return DateRange.create( start ).asWholeDayFromStart();
  }

  static forYear( year:number )
  {
    return DateRange.create( DateHelper.createYMD( year ), DateHelper.createYMD( year, 12, 31, 23, 59, 59 ) ); 
  }

  toMsRange()
  {
    return new Range( this.start.getTime(), this.end.getTime() );
  }

  overlaps( other:DateRange )
  {
    let otherRange = other.toMsRange();
    let ownRange   = this.toMsRange();

    return ownRange.overlaps( otherRange );
  }

  getOverlap( other:DateRange )
  {
    let otherRange = other.toMsRange();
    let ownRange   = this.toMsRange();

    let overlap = ownRange.getOverlap( otherRange );
    
    if ( ! overlap )
    {
      return null;
    }

    return DateRange.fromMs( overlap );
  }

  static fromMs( rangeInMs:Range )
  {
    var start = new Date( rangeInMs.min );
    var end   = new Date( rangeInMs.max );

    return DateRange.create( start, end );
  }

  contains( date:Date )
  {
    if ( DateMath.isBefore( date, this.start ) )
    {
      return false;
    }

    if ( DateMath.isAfter( date, this.end ) )
    {
      return false;
    }

    return true;
  }

  differenceMsTo( date:Date )
  {
    if ( this.contains( date ) )
    {
      return 0;
    }

    if ( DateMath.isBefore( date, this.start ) )
    {
      return DateMath.getDifferenceMs( date, this.start );
    }

    return DateMath.getDifferenceMs( this.end, date ); 
  }

  getAbsoluteDifferenceTo( date:Date )
  {
    let differenceMs = this.differenceMsTo( date );

    return Math.abs( differenceMs / 1000 );
  }

  asWholeDayFromStart()
  {
    let start = new Date( this.start );
    start.setHours( 0, 0, 0 );

    let end   = new Date( this.start );
    end.setDate( end.getDate() + 1 );

    return DateRange.create( start, end );
  }

  iterateDays( callback:(d:Date)=>void )
  {
    let it = new Date( this.start );

    while ( DateMath.isBeforeOrEquals( it, this.end ) ) 
    {
      callback( it );

      it = DateMath.addDays( it, 1 );
    };    


  }

  get durationInMilliseconds()
  {
    return this.end.getTime() - this.start.getTime();
  }

  get duration()
  {
    return this.durationInMilliseconds / 1000;
  }

  get durationInMinutes()
  {
    return this.duration / 60;
  }

  get durationInHours()
  {
    return this.durationInMinutes / 60;
  }
}
